import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d972ce70&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d972ce70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d972ce70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d972ce70')) {
      api.createRecord('d972ce70', component.options)
    } else {
      api.reload('d972ce70', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d972ce70&scoped=true&", function () {
      api.rerender('d972ce70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUh9a3P9PJMR/JS/comp/GuestBox.vue"
export default component.exports